/**
 * Fisher-Yates shuffle — returns a new shuffled array.
 */
export const shuffleArray = (array) => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

/**
 * Maps a project/participant status string to an Amplify Badge variation.
 */
export const getStatusBadgeVariation = (status) => {
  switch ((status || '').toLowerCase()) {
    case 'active':
    case 'success':
    case 'confirmed':
    case 'completed':
    case 'current':
      return 'success';
    case 'draft':
    case 'setup':
    case 'setting up':
    case 'pending':
    case 'warning':
    case 'force_change_password':
      return 'warning';
    case 'paused':
    case 'error':
      return 'error';
    case 'archived':
      return 'default';
    default:
      return 'info';
  }
};

/**
 * Obfuscates an email address for privacy display.
 * Shows full address for the current user; truncates domain for others.
 */
export const obfuscateEmail = (email, currentUserEmail) => {
  if (email === currentUserEmail) return email;
  const [name, domain] = email.split('@');
  if (!domain) return email;
  return `${name}@${domain.substring(0, 3)}...`;
};

/**
 * Formats an ISO date string for display.
 */
export const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  return new Date(dateString).toLocaleString();
};
